module.exports = __webpack_public_path__ + "static/media/indigenous.bdf09088.mp4";